/**
 * NavItem — a single navigable item in the sidebar.
 *
 * Renders as a proper <Link> for native browser link behavior (ctrl+click, etc.)
 * Uses NavRow for the shared row layout.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import NavRow from './NavRow';
import NavBadge from './NavBadge';

interface NavItemProps {
  condensed?: boolean;
  label?: string;
  icon?: React.ReactElement;
  iconSize?: number;
  route?: string;
  currentRoute?: string;
  disabled?: boolean;
  badgeCount?: number;
}

const NavItem = ({ condensed, label, icon, iconSize, route, currentRoute, disabled, badgeCount }: NavItemProps) => {
  const isActive = route === '/' ? currentRoute === '/' : !!(route && currentRoute?.startsWith(route));
  const hasBadge = !!(badgeCount && badgeCount > 0);

  const row = (
    <NavRow
      condensed={condensed}
      icon={icon}
      iconSize={iconSize}
      label={label}
      active={isActive}
      disabled={disabled}
      iconBadge={condensed && hasBadge ? <NavBadge count={badgeCount!} condensed /> : undefined}
      endAdornment={!condensed && hasBadge ? <NavBadge count={badgeCount!} /> : undefined}
    />
  );

  if (disabled) return row;

  return (
    <Link to={route || '/'} style={{ textDecoration: 'none', color: 'inherit' }}>
      {row}
    </Link>
  );
};

export default NavItem;
